<template >  
<div >
  <el-row class="table-grid-content">
			<el-col :span="3" >
				<el-input v-model="selecttypeName" placeholder="请输入类型名称"></el-input>
			</el-col>
            <el-col :span="3"  style="margin-left:0.5rem;">
         <el-select v-model="selectPurchaseType" placeholder="请选择机构购买类型">
           <el-option key=""
          label=""
          value="" >全部</el-option>
       <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
				
			</el-col>
			<el-col :span="3" class="grid" :gutter="1" style="margin-left: 2rem;">
				<el-button type="success" @click="selectinit" icon="el-icon-search">搜索</el-button>
			</el-col>
			<el-col :span="2" class="grid" :gutter="15" style="margin-left: -2rem">
				<el-button type="primary" @click="addParamete()">增加</el-button>
			</el-col>
		</el-row>

  <el-table :data="parameterData" border style="width: 100%; margin-top: 1rem;">
    <el-table-column prop="id" label="id" v-if="show"></el-table-column>
    <el-table-column prop="typeName" label="类型名称"></el-table-column>
    <el-table-column prop="purchaseType" label="购买类型" :formatter="purchaseTypeFormat"></el-table-column>
    <el-table-column prop="purchaseNumber" label="数量" :formatter="purchaseNumberFormat"></el-table-column>
    <el-table-column prop="duration" label="时长(月）"></el-table-column>
    <el-table-column prop="originalPrice" label="原价"></el-table-column>
    <el-table-column prop="presentPrice" label="现价"></el-table-column>
    <el-table-column prop="sequence" label="排序"></el-table-column>
    <el-table-column label="操作">
    <template slot-scope="scope">
      <el-button type="primary" size="small" @click="parameterEdit(scope.$index, scope.row)">编辑</el-button>
      <el-button type="danger" size="small" @click="parameterDelete(scope.row)">删除</el-button>    
    </template>
  </el-table-column>
 </el-table>


  <el-pagination
    @size-change="sizeChange"
    @current-change="currentChange"
    :page-sizes="[100]"   
    :page-size="page.pageSize"
    layout="total, sizes, prev, pager, next"
    :total="page.totalRecords">
  </el-pagination>
  

<!--新增-->
  <el-dialog title="新增价格单" :visible="addParameteForm" size="tiny" :modal-append-to-body='false' @close='closeDialog'>
  <el-form id="#addsForm" ref="addsForm" :model="addsForm" label-width="150px">
    <el-form-item label="类型名称" prop="typeName" :rules="[{required: true,message: '请输入正确值', trigger: 'blur' }]">
      <el-input  v-model="addsForm.typeName" max-length="10"></el-input>
    </el-form-item>
    <el-form-item label="购买类型" prop="purchaseType">
      <el-select v-model="addsForm.purchaseType" placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="购买数量" prop="purchaseNumber" :rules="[{required: true,message: '请输入正确值', trigger: 'blur' }]">
      <el-input type="number" min=0 v-model="addsForm.purchaseNumber" :require="true"></el-input>
    </el-form-item>
    <el-form-item  label="时长（月）" prop="duration" :rules="[{required: true,message: '请输入正确值', trigger: 'blur' }]">
      <el-input type="number" min=0 v-model="addsForm.duration"></el-input>
    </el-form-item>
    <el-form-item label="原价" prop="originalPrice" :rules="[{required: true,message: '请输入正确值', trigger: 'blur' }]">
      <el-input type="number" min=0 v-model="addsForm.originalPrice"></el-input>
    </el-form-item>
    <el-form-item label="现价" prop="presentPrice" :rules="[{required: true,message: '请输入正确值', trigger: 'blur' }]">
      <el-input type="number" min=0 v-model="addsForm.presentPrice"></el-input>
    </el-form-item>   
    <el-form-item label="排序" prop="sequence" :rules="[{required: true,message: '请输入正确值', trigger: 'blur' }]">
      <el-input type="number" min=0 v-model="addsForm.sequence"></el-input>
    </el-form-item>    
    <el-form-item>
      <el-button type="primary" @click="studentAdd()">确定</el-button>
      <el-button @click="addParameteForm = false;canceladdT('formt')">取消</el-button>
    </el-form-item>
  </el-form>
</el-dialog>

<!--修改-->
  <el-dialog title="修改价格单" :visible="editParameteForm" size="tiny" :modal-append-to-body='false' @close='closeDialog'>
  <el-form id="#editsForm" ref="editsForm" :model="editsForm" label-width="150px">
    
      <el-input  v-model="editsForm.id" v-if="value"></el-input>
    
    <el-form-item label="类型名称" prop="typeName">
      <el-input  v-model="editsForm.typeName" max-length="10"></el-input>
    </el-form-item>
    <el-form-item label="购买类型" prop="purchaseType">
      <el-select v-model="editsForm.purchaseType" placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="购买数量" prop="purchaseNumber" >
      <el-input type="number" min=0 v-model="editsForm.purchaseNumber"></el-input>
    </el-form-item>
    <el-form-item label="时长（月）" prop="duration">
      <el-input type="number" min=0 v-model="editsForm.duration"></el-input>
    </el-form-item>
    <el-form-item label="原价" prop="originalPrice">
      <el-input type="number" min=0 v-model="editsForm.originalPrice"></el-input>
    </el-form-item>
    <el-form-item label="现价" prop="presentPrice">
      <el-input type="number" min=0 v-model="editsForm.presentPrice"></el-input>
    </el-form-item>   
    <el-form-item label="排序" prop="sequence">
      <el-input type="number" min=0 v-model="editsForm.sequence"></el-input>
    </el-form-item>    
    <el-form-item>
      <el-button type="primary" @click="studentEdit()">确定</el-button>
      <el-button @click="editParameteForm = false;canceladdT('formt')">取消</el-button>
    </el-form-item>
  </el-form>
</el-dialog>
</div>
</template>

<script>
export default {
  data(){
    return{
      value:false,
      show:false,
      addParameteForm:false,
      editParameteForm:false,
      parameterData:[],
      selecttypeName:"",
      selectPurchaseType:"",
      page:{
        pageSize: 100, //每页条数,  默认10条
        totalRecords: 0, //总条数
        totalPages: 0, //总页数
        pageNum:0
      },
      options: [{
          value: 1,
          label: '按校区数购买'
        }, {
          value: 2,
          label: '按学员数购买'
        }] ,
        addsForm:{
  
          typeName:'',
          purchaseNumber:'',
          duration:'',
          originalPrice:'',
          presentPrice:'',
          sequence:'100'
        } 
         ,
        editsForm:{
          id:'',
          typeName:'',
          purchaseNumber:'',
          duration:'',
          originalPrice:'',
          presentPrice:'',
          sequence:'100'
        },
        apiUrl:''          
     
    }
  },
created(){
 this.apiUrl = localStorage.aipUrl
},
  mounted(){
    this.init();
      },
  methods:{
    isNull(rule, value, callback){
      if (value <=0) {
        callback(new Error('请输入正确值'));
      }
    },
    purchaseTypeFormat(row, column) {
    if (row.purchaseType === 1) {
      return '按校区购买'
    } else  {
      return '按学员数购买'
    } 
  },
   purchaseNumberFormat(row, column) {
    if (row.purchaseType === 1) {
      return row.purchaseNumber+'校区'
    } else  {
      return row.purchaseNumber+'学员'
    } 
  },
   selectinit(){
      this.page.pageNum=0;
      this.init();
    },
    init(){
      this.parameterData=[];
      let {pageNum,pageSize}=this.page;
      this.axios({
          method:'post',         
          url:`${this.apiUrl}/parmeter/findPriceList?`+(new Date()).valueOf(),
          data: {
            pageNum: this.page.pageNum,
            typeName: this.selecttypeName,
            pageSize: this.page.pageSize,
            purchaseType:this.selectPurchaseType

          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': sessionStorage.getItem("token")
          }
      }).then(res=>{                  
          if(res.data.stateCode==200){
            this.page.totalRecords=res.data.data.totalRecords; //总条数
            const studentArray=res.data.data.list;
            this.parameterData=studentArray;
          }else if(res.data.stateCode==403){
            this.$message.error("您没有相应操作权限，请联系系统管理员！");
          }else{
            this.$message.error(res.data.msg);
          }
      }).catch(error=>{
          
      })
    

    },
    // 每页显示多少条数据
sizeChange(val) {
  this.page.pageSize = val;
  this.init();
},
//翻页
currentChange(val) {
  this.page.pageNum=val-1;
  console.log(this.page.pageNum);
  this.init();
},
// 点击模态框关闭按钮关闭模态框
closeDialog(){
  this.addParameteForm = false;
  this.editParameteForm = false;
},
// 点击新增按钮
addParamete(){
    this.addsForm={};
    this.addParameteForm = true;   //原来隐藏的新增信息模态框显示
},
//确定
 studentAdd(){
    let parameteList=this.addsForm;
    let {typeName,purchaseNumber,duration,originalPrice,presentPrice,sequence,purchaseType} = parameteList;
//判断数据是否为空
    if(typeName === undefined || duration === undefined || originalPrice === undefined || presentPrice === undefined || sequence === undefined || purchaseType === undefined || purchaseNumber == undefined ){
      this.$message.error('新增内容每一项都不准为空');
    }else{
//每一条都不为空时才向后台发送http请求
       this.axios({
          method:'post',         
          url:`${this.apiUrl}/parmeter/priceListAdd?`+(new Date()).valueOf(),
          data: {
            typeName: this.addsForm.typeName,
            purchaseNumber: this.addsForm.purchaseNumber,
            duration:this.addsForm.duration,
            originalPrice:this.addsForm.originalPrice,
            presentPrice:this.addsForm.presentPrice,
            sequence:this.addsForm.sequence,
            purchaseType:this.addsForm.purchaseType

          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': sessionStorage.getItem("token")
          }
      }).then(res=>{                  
          if(res.data.stateCode==200){
             this.$set(this.addsForm,{});
             this.init();   //重新渲染数据列表
             this.addParameteForm = false;
              this.$message({
          message: res.data.msg,
          type: 'success'
        });
          }else if(res.data.stateCode==403){
            this.$message.error("您没有相应操作权限，请联系系统管理员！");
          }else{
            this.$message.error(res.data.msg);
          }
      }).catch(error=>{
          
      })

     
    }
},
// 点击修改修改按钮
parameterEdit(index,row){
    this.editParameteForm = true; //编辑信息模态框显示
    this.editsForm = Object.assign({}, row);  // 获得所有数据显示在编辑信息模态框里面
},
//修改确定
 studentEdit(){
    let parameteList=this.editsForm;  
    let {typeName,purchaseNumber,duration,originalPrice,presentPrice,sequence,purchaseType} = parameteList;
//判断数据是否为空
    if(typeName==''||purchaseNumber==''||duration==''||originalPrice==''||presentPrice==''||sequence==''||purchaseType==''){
      this.$message.error('新增内容每一项都不准为空')
    }else{
//每一条都不为空时才向后台发送http请求
       this.axios({
          method:'post',         
          url:`${this.apiUrl}/parmeter/priceListUpdate?`+(new Date()).valueOf(),
          data: {
            id:this.editsForm.id,
            typeName: this.editsForm.typeName,
            purchaseNumber: this.editsForm.purchaseNumber,
            duration:this.editsForm.duration,
            originalPrice:this.editsForm.originalPrice,
            presentPrice:this.editsForm.presentPrice,
            sequence:this.editsForm.sequence,
            purchaseType:this.editsForm.purchaseType

          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': sessionStorage.getItem("token")
          }
      }).then(res=>{                  
          if(res.data.stateCode==200){            
             this.init();   //重新渲染数据列表
             this.editParameteForm = false;
              this.$message({
          message: res.data.msg,
          type: 'success'
        });
          }else if(res.data.stateCode==403){
            this.$message.error("您没有相应操作权限，请联系系统管理员！");
          }else{
            this.$message.error(res.data.msg);
          }
      }).catch(error=>{
          
      })

     
    }
},
parameterDelete(row){
  this.$confirm('此操作将永久条价格单 ' + row.typeName + ', 是否继续?', '提示', { type: 'warning' })
    .then(() => { // 向服务端请求删除
      this.axios({
          method:'post',         
          url:`${this.apiUrl}/parmeter/priceListDel?`+(new Date()).valueOf(),
          data: {
            id:row.id,       

          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': sessionStorage.getItem("token")
          }
      }).then(res=>{                  
          if(res.data.stateCode==200){            
             this.init();   //重新渲染数据列表
              this.$message({
          message: res.data.msg,
          type: 'success'
        });
          }else if(res.data.stateCode==403){
            this.$message.error("您没有相应操作权限，请联系系统管理员！");
          }else{
            this.$message.error(res.data.msg);
          }
      }).catch(error=>{
          
      })
    }) .catch(() => {
    this.$message.info('已取消操作!');
  });
}
  }
}
</script>
<style scoped>

.el-table /deep/ th{
    background-color: #EEEFF1;
}
</style>


// WEBPACK FOOTER //
// src/views/parameterList.vue